<template>
  <div>
    <section class="sidebar">
      <router-link :to="{ name: 'landingPage' }">
        <div>
          <img
            :class="{ active: this.$route.path == '/' }"
            src="@/../public/image/logo/calendar-logo.png"
            alt="home"
          style="height: 100%; width: 90%; margin: 10px;"
          />
        </div>
      </router-link>
      <div class="icons-section">
        <router-link :to="{ name: 'landingPage' }">
          <div>
            <img
              :class="{ active: this.$route.path == '/' }"
              src="@/../public/image/icon/home.svg"
              alt="home"
            />
            <span class="icon-text">Home</span>
          </div>
        </router-link>

        <router-link :to="{ name: 'eventPage' }">
          <div class="icon-child">
            <img
              :class="{ active: this.$route.path == '/event' }"
              src="@/../public/image/icon/list.svg"
              alt="detail"
            />
            <span class="icon-text">Event</span>
          </div>
        </router-link>
        <router-link :to="{ name: 'pdf' }">
          <div class="icon-child">
            <img
              :class="{ active: this.$route.path == '/pdf' }"
              src="@/../public/image/icon/file-text.svg"
              alt="detail"
            />
            <span class="icon-text">Pdf</span>
          </div>
        </router-link>
        <router-link :to="{ name: 'video' }">
          <div class="icon-child">
            <img
              :class="{ active: this.$route.path == '/video' }"
              src="@/../public/image/icon/video.svg"
              alt="detail"
            />
            <span class="icon-text">Video</span>
          </div>
        </router-link>
        <router-link :to="{ name: 'Notification' }">
          <div class="icon-child">
            <img
              :class="{ active: this.$route.path == '/Notification' }"
              src="@/../public/image/icon/bell.svg"
              alt="detail"
            />
            <!-- <span class="icon-text">Push Notification</span> -->
            <span class="icon-text">Notification</span>
          </div>
        </router-link>
        <router-link :to="{ name: 'Holliday' }">
          <div class="icon-child">
            <img
              :class="{ active: this.$route.path == '/Holliday' }"
              src="@/../public/image/icon/calendar.svg"
              alt="detail"
            />
            <!-- <span class="icon-text">Push Notification</span> -->
            <span class="icon-text">Holliday</span>
          </div>
        </router-link>
        <div class="icon-child">
          <div @click="showLogoutModal" style="cursor: pointer">
            <img
              src="@/../public/image/icon/log-out.svg"
              alt="detail"
              class="white-icon"
            />
            <span class="icon-text">Logout</span>
          </div>
        </div>
      </div>
      <div>
        <span style="color: #fff;">
          Powered By
          <a
            href="https://uddhami.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/image/logo/Uddhami-logo.png"
              alt="logo"
              style="height: 100%; width: 50%; padding: 10px 0"
            />
          </a>
        </span>
      </div>
    </section>

    <!-- Logout Confirmation Modal -->
    <a-modal
      :visible="isLogoutModalVisible"
      title="लगआउट पुष्टि गर्नुहोस्"
      ok-text="हो"
      cancel-text="होइन"
      @ok="confirmLogout"
      @cancel="cancelLogout"
    >
      <p>के तपाईं निश्चित रूपमा लगआउट गर्न चाहनुहुन्छ?</p>
    </a-modal>
    
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Modal } from "ant-design-vue";

export default {
  components: {
    "a-modal": Modal,
  },
  data() {
    return {
      isLogoutModalVisible: false,
    };
  },
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),

    // Show logout confirmation modal
    showLogoutModal() {
      this.isLogoutModalVisible = true;
    },

    // Confirm logout action
    confirmLogout() {
      this.isLogoutModalVisible = false;
      this.signOutAction()
        .then(() => {
          this.$notify.success({
            position: "bottom right",
            msg: "Logout successfully!",
            timeout: 2000,
            styles: {
              minWidth: null,
              maxWidth: "calc(100% - 40px)",
              width: 250,
              height: 70,
            },
          });
          this.$router.replace({ name: "Login" });
        })
        .catch(() => {
          this.$notify.error({
            position: "bottom right",
            msg: "Logout failed. Please try again!",
            timeout: 2000,
            styles: {
              minWidth: null,
              maxWidth: "calc(100% - 40px)",
              width: 250,
              height: 70,
            },
          });
        });
    },
    cancelLogout() {
      this.isLogoutModalVisible = false;
    },
  },
};
</script>

<style scoped>
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 100vh;
  min-width: 200px;
  max-width: 200px;
  background: #254594;
  /* border-top-right-radius: 50px; */
  /* border-bottom-right-radius: 50px; */
}
.icon-text {
  color: #fff;
  margin-left: 20px;
}
.icon-child {
  margin-top: 25px;
}
.icons-section {
  margin-left: 10px;
}
.active {
  margin-left: 10px;
}
.white-icon {
  filter: invert(100%) brightness(100%) grayscale(100%);
}
</style>
